/**
 * Spec 234 §5 — the bar chart rule, as a reusable primitive: a light column
 * for the range, an ink dash at the value. The one mark that carries the
 * point takes the action colour and its column is lifted a step.
 *
 * A zero is a dash on the floor; missing data draws no dash — pass `null`
 * for "not evaluable" and `0` for a measured zero. They must never collapse
 * to the same fraction upstream, or this component can't tell them apart.
 */
export interface MeasureBarProps {
  /** 0–1 fraction within the range, or `null` for no measurement to mark. */
  fraction: number | null;
  /** Marks this as the one bar in its group that carries the point: the
   *  dash takes the action colour and the column lifts a step. At most one
   *  per group of bars, same rule as `Stat`'s `attention`. */
  emphasize?: boolean;
  className?: string;
}

export function MeasureBar({ fraction, emphasize, className }: MeasureBarProps) {
  const pct = fraction == null ? null : Math.min(100, Math.max(0, fraction * 100));
  return (
    <div
      className={`hub-measure-bar${emphasize ? ' hub-measure-bar--emphasis' : ''}${className ? ` ${className}` : ''}`}
    >
      {pct != null && <span className="hub-measure-bar__dash" style={{ left: `${pct}%` }} />}
    </div>
  );
}
